import { Component, ElementRef, Inject, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { BaseModalComponent } from '../modal/base-modal/base-modal.component';
import { ProgressService } from '../../service/progress.service';
import {
  Action,
  ListItemDetailsActionInvoke,
  ListItemDetailsData
} from '../list-item-details/list-item-details.component';

@Component({
  selector: 'app-list-item-details-modal',
  templateUrl: './list-item-details-modal.component.html',
  styleUrls: ['./list-item-details-modal.component.scss']
})
export class ListItemDetailsModalComponent<T> extends BaseModalComponent {

  @ViewChild('dialogContent', {static: true}) protected progressContainer!: ElementRef;

  data: ListItemDetailsData<T>;

  constructor(dialogRef: MatDialogRef<ListItemDetailsModalComponent<T>>,
              progressService: ProgressService,
              @Inject(MAT_DIALOG_DATA) data: ListItemDetailsData<T>) {
    super(dialogRef, progressService);

    this.data = data;
  }

  proceedAllowed(): boolean {
    return true;
  }

  proceed(): void {
    this.closeModal();
  }

  actionTriggered(action: Action) {
    const data: ListItemDetailsActionInvoke<T> = {
      action: action.code,
      component: this.data.component
    };

    this.closeModal(data);
  }
}
